import { Navigate, Outlet } from 'react-router-dom'
import { authService } from 'builder/services/AuthService'

export const UnauthorizedZone = () => {
  return authService.isLoggedIn() ? <Navigate to="/" /> : <Outlet />
}
